// If the dispatched action contains { meta: { isError: true } }, dispatch some actions
// that result in a modal being displayed to the user to tell them of the error

import { errorModalSetBody, openErrorModal, setRebuildStatus } from "app/ui/actions";

export const errorMessage = store => next => action => {
  if (action.error) {
    store.dispatch(errorModalSetBody(action.payload.message));
    store.dispatch(openErrorModal());
    if (action.payload.message && action.payload.message.includes("Service unavailable due to actively running rebuild") ) {
      store.dispatch(setRebuildStatus({rebuildRunning: true}));
    }
  }
  next(action);
};

export default errorMessage;
